import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class ServiceTypeEnumConverter implements JsonCustomConvert<ServiceTypeEnum> {
	serialize() { }

	deserialize(data: any): ServiceTypeEnum {
		switch (data) {
			case 'PASSPOINT':
				return ServiceTypeEnum.PASSPOINT;
			case 'CAPTIVE':
				return ServiceTypeEnum.CAPTIVE;

			default:
				return ServiceTypeEnum.PASSPOINT;
		}
	}
}

export enum ServiceTypeEnum {
	PASSPOINT = 'PASSPOINT',
	CAPTIVE = 'CAPTIVE',

}